var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper"},[_c('div',{staticClass:"page-inner bg-light"},[_c('div',{staticClass:"page-content-wrapper bg-transparent m-0"},[_c('start-layout-navbar'),_c('start-layout-body'),_c('start-layout-footer')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }